import { Button } from 'primereact'
import { useSelector } from 'react-redux'
import vanBangProcessor from '../../processor/vanBangProcessor'
import { exportGroupExcel } from '../../utils/excel'
import { groupListByField } from '../../utils/list'
import ListVanBangWithView from './ListVanBangWithView'
import { getGioiTinh } from '../../constant/gioiTinh'

export default function DieuChinhVanBang() {
  const { truongId, khoaThiId } = useSelector((item) => {
    const { khoaThi, donViDangKyDuThi } = item
    return {
      khoaThiId: khoaThi.id,
      truongId: donViDangKyDuThi.id,
    }
  })
  const toast = useSelector((store) => store.notify.toast)

  const listNam = useSelector((state) => state.nam.datas)
  return (
    <>
      <ListVanBangWithView
        moduleTitle="Danh sách văn bằng đã duyệt"
        disable={['name', 'heDaoTao', 'hinhThucDaoTao']}
        headerLeft={
          <div>
            <Button
              icon="pi pi-file-excel"
              className="p-button-success ml-3"
              label="Xuất excel"
              onClick={async () => {
                const rs = await vanBangProcessor.export({ khoaThiId, truongId })
                if (rs.length === 0) {
                  toast({ type: 'error', message: 'Không có dữ liệu' })
                  return
                }
                const rsMap = rs.map((item) => {
                  const nam = listNam.find((n) => n.id === item.khoaThi.namId)
                  return {
                    ...item,
                    gioiTinh: getGioiTinh(item.gioiTinh),
                    maTruongTN: item.donViDangKyDuThi.code,
                    namTotNghiep: nam.name,
                    heDaoTaoName: item.heDaoTao.code,
                    hinhThucDaoTaoName: item.hinhThucDaoTao.code,
                    maTruong: item.truong.code,
                  }
                })
                const rsList = groupListByField(rsMap, 'namTotNghiep')
                exportGroupExcel(rsList, 'danhSachVanBang', {
                  id: 'TT',
                  hoTen: 'Hoten',
                  gioiTinh: 'Gioitinh',
                  ngaySinh: 'Ngaysinh',
                  noiSinh: 'Noisinh',
                  danToc: 'Dantoc',
                  xepLoai: 'Xeploai',
                  maTruongTN: 'Mã trường Tốt nghiệp',
                  namTotNghiep: 'Năm tốt nghiệp',
                  soHieu: 'Sohieu',
                  soCapBang: 'Socapbang',
                  heDaoTaoName: 'HeDaoTao',
                  hinhThucDaoTaoName: 'HinhThucDaoTao',
                  maTruong: 'MaTruongTHCS',
                  cccd: 'CCCD',
                  ghiChu: 'GhiChu',
                })
              }}
            />
          </div>
        }
      />
    </>
  )
}
